/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleDetails {
    getFixupPrototypeFunction() { return ScheduleDetails.fixupPrototype; }

    static newInstance(model: Partial<ScheduleDetails>): ScheduleDetails {
        let obj = Object.assign(new ScheduleDetails(), model);
        ScheduleDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleDetails>): ScheduleDetails {
        if (!model) return null;
        return ScheduleDetails.newInstance(<ScheduleDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleDetails) {
        if (!obj) return;

        models.ScheduleDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleDetails): boolean {
        Object.setPrototypeOf(obj, ScheduleDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.next_run === "string") {
            this.next_run = new Date(<string><any>this.next_run);
        }
        if (typeof this.last_run === "string") {
            this.last_run = new Date(<string><any>this.last_run);
        }
        if (typeof this.end_run === "string") {
            this.end_run = new Date(<string><any>this.end_run);
        }
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.schedule) {
            models.SchedulingDetails.fixupPrototype(this.schedule);
        }
        if (this.notification_configuration) {
            models.ScheduleExecutionNotificationConfiguration.fixupPrototype(this.notification_configuration);
        }
        if (this.background_job) {
            models.RecordIdentity.fixupPrototype(this.background_job);
        }
        if (this.execution_params) {
            for (let val of this.execution_params) {
                models.ScheduleExecutionParameterBase.fixupPrototype(val);
            }
        }
    }

    /**
     * ID of the schedule
     */
    schedule_id: string;

    /**
     * Schedule Name
     */
    name: string;

    /**
     * Category of the schedule.
     */
    category: models.ScheduleCategory;

    /**
     * Source of the schedule creation
     */
    source: models.ScheduleSource;

    /**
     * Description of the schedule
     */
    description: string;

    /**
     * Re-occurrence of the schedule
     */
    recurrence: models.ScheduleRecurrence;

    /**
     * When will the schedule run for the next time
     */
    next_run: Date;

    /**
     * When the last schedule triggered
     */
    last_run: Date;

    /**
     * Upto when the schedule should run
     */
    end_run: Date;

    /**
     * Schedule date and time details
     */
    schedule: models.SchedulingDetails;

    /**
     * Timezone of the schedule
     */
    timezone: string;

    /**
     * ID of the resource which is scheduled. Can be retrieved using the respective List API
     */
    resource: string;

    /**
     * Input Parameters for the resource that is scheduled which is a JSON string
     */
    resource_args: string;

    /**
     * Execution parameters for the schedule.
     */
    execution_params: Array<models.ScheduleExecutionParameterBase>;

    /**
     * Notification configuration for the schedule.
     */
    notification_configuration: models.ScheduleExecutionNotificationConfiguration;

    /**
     * Flag to represent whether the schedule is active or not.
     */
    is_active: boolean;

    /**
     * Flag to represent whether the schedule is system scheduled or not.
     */
    is_system_schedule: boolean;

    /**
     * Tenant owning the schedule.
     */
    tenant_id: string;

    /**
     * When the schedule is created
     */
    created_at: Date;

    /**
     * Who has created the schedule
     */
    created_by: string;

    /**
     * When the schedule is updated
     */
    updated_at: Date;

    /**
     * Who has updated the schedule
     */
    updated_by: string;

    /**
     * Identity of the background job used for processing schedule. null if the job has completed
     */
    background_job: models.RecordIdentity;

}
